import { pb } from './pb';

// Public fetch for team display
export async function fetchTeamPublic(){
  const res = await pb.collection('team_members').getFullList({
    filter: 'published=true',
    sort: 'order,name',
  });
  return res;
}

// Admin helpers
export async function fetchTeamAdmin(page = 1, perPage = 30, search = ''){
  const filters = [];
  if(search){
    const s = search.replace(/"/g, '\\"');
    filters.push(`name ~ "%${s}%" || role ~ "%${s}%"`);
  }
  const filter = filters.join(' && ');
  return pb.collection('team_members').getList(page, perPage, {
    filter,
    sort: 'order,name',
  });
}

export async function createTeamMember(data){
  return pb.collection('team_members').create(data);
}

export async function updateTeamMember(id, data){
  return pb.collection('team_members').update(id, data);
}

export async function deleteTeamMember(id){
  return pb.collection('team_members').delete(id);
}
